import React from "react";
import "@styles/pages/Home/ExclusiveMemberPrivileges.scss";
import { Trans, useTranslation } from "react-i18next";
import { Box, Button, Typography, useMediaQuery } from "@mui/material";
import { delay, motion } from "framer-motion";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { gaEvent } from "@utils/gaEvent";

const ExclusiveMemberPrivileges = () => {
  const { i18n } = useTranslation();
  const isPad = useMediaQuery("(max-width:768px)");
  const memberInfoData = useSelector(
    (state) => state.memberInfo.memberInfoData
  );
  const navigate = useNavigate();

  const rewardsFunList = () => {
    return [
      {
        img: `${process.env.PUBLIC_URL}/assets/images/home/gift_img_1.png`,
        textKey: "home:fabulous_gifts",
      },
      {
        img: `${process.env.PUBLIC_URL}/assets/images/home/gift_img_4.png`,
        textKey: "home:shopping_vouchers",
      },
    ];
  };

  const memberBenefitList = () => {
    return [
      {
        img: `${process.env.PUBLIC_URL}/assets/images/home/gift_img_2.png`,
        textKey: "home:free_tutorials",
      },
      {
        img: `${process.env.PUBLIC_URL}/assets/images/home/gift_img_3.png`,
        textKey: "home:3x_birthday_s_dollar",
      },

      {
        img: `${process.env.PUBLIC_URL}/assets/images/home/gift_img_5.png`,
        textKey: "home:event_invitation",
      },
    ];
  };

  const shoppingPerks = () => {
    return [
      {
        img: `${process.env.PUBLIC_URL}/assets/images/home/gift_img_6.png`,
        textKey: "home:samsung_rewards_shopping_rebate",
      },
      {
        img: `${process.env.PUBLIC_URL}/assets/images/home/gift_img_7.png`,
        textKey: "home:shopping_offer",
      },
    ];
  };

  return (
    <Box className="exclusive-member-privileges-container">
      <Box className="max-width-container">
        <Typography className="title">
          <img
            className="logo"
            src={`${process.env.PUBLIC_URL}/assets/images/global/mobile_logo.png`}
            alt="logo"
            onClick={() => navigate("/")}
          />
          <Trans i18nKey="home:exclusive_member_privileges" />
        </Typography>
        <Box className="outline-privileges-container">
          <motion.Box
            className="privileges-container"
            // initial={{ opacity: 1, y: 50 }}
            // whileInView={{ opacity: 1, y: 0 }}
            // viewport={{ once: false, amount: 0.7 }}
            // transition={{ duration: 1 }}
          >
            <Box className="rewards-fun-container">
              <Typography className="privileges-title">
                <Trans i18nKey="home:rewards_fun" />
              </Typography>
              <Box className="gift-container">
                {rewardsFunList().map((item, index) => (
                  <motion.Box
                    className="gift"
                    key={index}
                    // initial={{ opacity: 0, y: 0 }}
                    // whileInView={{ opacity: 1, y: 0 }}
                    // viewport={{ once: false, amount: 0.7 }}
                    // transition={{ duration: 1, delay: isPad ? 0 : index * 0.3 }}
                  >
                    <img
                      className="gift-image"
                      src={item.img}
                      alt={`gift-icon-${index + 1}`}
                    />
                    <Typography className="gift-text">
                      <Trans i18nKey={item.textKey} />
                    </Typography>
                  </motion.Box>
                ))}
              </Box>
            </Box>
            <Box className="member-benefit-container">
              <Typography className="privileges-title">
                <Trans i18nKey="home:member_benefit" />
              </Typography>

              <Box className="gift-container">
                {memberBenefitList().map((item, index) => (
                  <motion.Box
                    className="gift"
                    key={index}
                    // initial={{ opacity: 0, y: 0 }}
                    // whileInView={{ opacity: 1, y: 0 }}
                    // viewport={{ once: false, amount: 0.7 }}
                    // transition={{ duration: 1, delay: isPad ? 0 : index * 0.3 }}
                  >
                    <img
                      className="gift-image"
                      src={item.img}
                      alt={`gift-icon-${index + 1}`}
                    />
                    <Typography className="gift-text">
                      <Trans i18nKey={item.textKey} />
                    </Typography>
                  </motion.Box>
                ))}
              </Box>
            </Box>
            <Box className="shopping-perks-container">
              <Typography className="privileges-title">
                <Trans i18nKey="home:shopping_perks" />
              </Typography>

              <Box className="gift-container">
                {shoppingPerks().map((item, index) => (
                  <motion.Box
                    className="gift"
                    key={index}
                    // initial={{ opacity: 0, y: 0 }}
                    // whileInView={{ opacity: 1, y: 0 }}
                    // viewport={{ once: false, amount: 0.7 }}
                    // transition={{
                    //   duration: 1,
                    //   delay: isPad ? 0 : 1.5 + index * 0.3,
                    // }}
                  >
                    <img
                      className="gift-image"
                      src={item.img}
                      alt={`gift-icon-${index + 1}`}
                    />
                    <Typography className="gift-text">
                      <Trans i18nKey={item.textKey} />
                    </Typography>
                  </motion.Box>
                ))}
              </Box>
            </Box>
            {!memberInfoData && (
              <Typography
                className="loading-button join-to-clubs-button"
                onClick={() => {
                  gaEvent("clubs_homepage","join_clubs","join_clubs_button_2");
                  navigate("/login");
                }}
              >
                <Trans i18nKey="home:join_clubS" />
              </Typography>
            )}
          </motion.Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ExclusiveMemberPrivileges;
